/**
 * Hide Yotpo star-rating widgets when a product has 0 reviews.
 * Covers PLP product cards, PDP app blocks, and AJAX-refreshed grids.
 */
(function () {
  var WIDGET_SELECTOR = '.yotpo-widget-instance';
  var COUNT_SELECTOR = '.yotpo-sr-bottom-line-text';
  var PROCESSED_ATTR = 'data-yotpo-zero-checked';
  var scheduled = false;

  function getReviewCount(widget) {
    var textEl = widget.querySelector(COUNT_SELECTOR);
    if (!textEl) return null;

    var match = textEl.textContent.match(/(\d[\d,]*)/);
    if (!match) return null;

    return parseInt(match[1].replace(/,/g, ''), 10);
  }

  function processWidget(widget) {
    if (widget.getAttribute(PROCESSED_ATTR) === '1') return;

    var count = getReviewCount(widget);
    if (count === null) return;

    widget.setAttribute(PROCESSED_ATTR, '1');

    if (count === 0) {
      widget.style.display = 'none';
      widget.setAttribute('aria-hidden', 'true');
      widget.classList.add('yotpo-zero-reviews');
    }
  }

  function hideZeroReviewWidgets(root) {
    var scope = root && root.nodeType === 1 ? root : document;

    if (scope.matches && scope.matches(WIDGET_SELECTOR)) {
      processWidget(scope);
    }

    var widgets = scope.querySelectorAll
      ? scope.querySelectorAll(WIDGET_SELECTOR)
      : [];

    for (var i = 0; i < widgets.length; i++) {
      processWidget(widgets[i]);
    }
  }

  function scheduleScan() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      hideZeroReviewWidgets(document);
    });
  }

  function start() {
    hideZeroReviewWidgets(document);

    var observer = new MutationObserver(scheduleScan);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', scheduleScan);
})();
